import { ImgWebConfig } from '../types';

export const imgWebConfig: ImgWebConfig = {
  brand: 'lvbet',
  hostUrlDev: 'https://image-assets-server-dot-cms-headless-gae.ew.r.appspot.com/',
  hostUrlProd: 'https://lvbet.lv/'
};
